export const testimonialImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/5ymBpWPFb24L8gjeeCqdmH/Imagen_de_ChatGPT_27_sept_2026,_13_56_20.webp',
    alt: 'Mensaje de Facebook Messenger de Ana López felicitando por las fichas con objetivo, ejecución, dosis, error frecuente y corrección'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dA3UERNHdRwvo4YkDN3kMr/Imagen_de_ChatGPT_27_sept_2026,_13_55_40.webp',
    alt: 'Correo de Laura Sánchez contando que usa muchísimo el checklist de correcciones y las progresiones para adaptar ejercicios'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/uSGD8GoTC7ZD8HsQJjANkr/Imagen_de_ChatGPT_27_sept_2026,_13_47_33.webp',
    alt: 'Comentario de Instagram de marta.pilates diciendo que el mapa para montar las clases le está salvando'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/g1jRpx83RTMwnW5zHxUQ3g/Imagen_de_ChatGPT_27_sept_2026,_13_48_21.png',
    alt: 'Publicación de Facebook de Elena García contando que usa el material como biblioteca de consulta organizada por objetivo'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/mSpcbRQrb5uQ2Y9AVUN4sR/Imagen_de_ChatGPT_27_sept_2026,_13_47_30.webp',
    alt: 'Mensaje de Facebook Messenger de Lucía Fernández sobre las progresiones y regresiones para grupos con niveles distintos'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8No9sAUFDTxRoexoduL7BB/Imagen_de_ChatGPT_27_sept_2026,_13_47_08.webp',
    alt: 'Mensaje de Facebook Messenger de Carmen Ruiz contando que ahora prepara las clases de forma más directa'
  }
];
